import {fetch} from '../utils/fetch'
import {casaApiUrl} from 'configs/casa-api'
import queryString from 'query-string'
import moment from 'moment-timezone'

function getProductWiseSalesAnalyticsDetails(filter, changesFrom, isExportCSV = false) {
  let {
    startDate, endDate, storeNames, productField, productFieldValues, advanceFilters,
    productFieldForStoreCategory, channels
  } = filter.toJSON()
  let startDateParam = moment(startDate).format('YYYY-MMM-DD')
  let endDateParam = moment(endDate).format('YYYY-MMM-DD')
  let query = queryString.stringify({
    stores: storeNames,
    channels,
    startDate: startDateParam,
    endDate: endDateParam,
    productField: changesFrom === 'summary' ? productFieldForStoreCategory : productField,
    productFieldValues: productFieldValues,
    advanceFilters: JSON.stringify(advanceFilters)
  }, {arrayFormat: 'bracket'})
  if (isExportCSV) {
    return fetch(window.open(`${casaApiUrl}/users/product-wise-sales-analytics/${isExportCSV}/filter?${query}`), {
      credentials: 'include',
      method: 'GET'
      // headers: {
      //   'Content-Type': 'application/json'
      // }
    }).then(r => r)
  } else {
    return fetch(`${casaApiUrl}/users/product-wise-sales-analytics/${isExportCSV}/filter?${query}`, {
      credentials: 'include',
      method: 'GET'
      // headers: {
      //   'Content-Type': 'application/json'
      // }
    }).then(r => r.json())
  }
}

export default {
  getProductWiseSalesAnalyticsDetails
}



// WEBPACK FOOTER //
// ./src/services/product-wise-sales-analytics-service.js